import { Action } from 'redux';

import { SetContentPermissions } from '../../bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '../../bootstrap/redux/actions/isActionFactory';
import { IContentInfo } from '../../spacesPlatform/models/IContentInfo';

export interface SetContentPermissionsAction extends Action {
  content: IContentInfo[];
}

export function setContentPermissions(content: IContentInfo[]) {
  return {
    type: SetContentPermissions,
    content: content
  };
}

export const isSetWorkbookPermissionsAction = isActionFactory<SetContentPermissionsAction>(SetContentPermissions);
